<template>
  <b-dialog :name="'new-house-form'" width="700" :focusTrap="false" @closed="clearData">
    <form class="uk-form-horizontal b-form" autocomplete="off" @submit.prevent="">
      <div v-if="errorMessage" class="uk-alert-danger uk-animation-slide-bottom-small" uk-alert>
        <p>{{ errorMessage }}</p>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle uk-width-1-1">
        <label class="form-column--left" for="street">Улица <span class="req-star">*</span></label>
        <div class="form-column--right" style="margin-right: 130px">
          <v-select
            v-model="street"
            id="street"
            :options="options"
            :class="{'select-error uk-animation-shake': $v.street.label.$error}"
            @search:blur="clearHouse"
            @input="updateHouses"
          ></v-select>
        </div>
      </div>
      <div class="uk-margin-small uk-flex uk-flex-middle uk-width-1-1">
        <label class="form-column--left" for="building">Дом <span class="req-star">*</span></label>
        <div class="form-column--right">
          <v-select
            v-model="building"
            id="building"
            :options="buildings"
            :disabled="buildingDisabled"
            :class="{'select-error uk-animation-shake': $v.building.label.$error}"
          ></v-select>
        </div>
      </div>
    </form>
    <div class="uk-flex uk-flex-center uk-margin-medium-top">
      <b-button name="Сохранить" color="red" class="margin-right_60" @click="Save" />
      <b-button name="Отменить" @click="$modal.hide('new-house-form')" />
    </div>
  </b-dialog>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import {required} from 'vuelidate/lib/validators'

import {mapActions} from 'vuex'

export default {
  name: 'CreateNewHouseForm',
  components: {
    vSelect
  },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      details: Object.assign({}, this.value),
      questionsKey: 1,
      errorMessage: '',
      street: {
        label: '',
        code: ''
      },
      options: [],
      building: {
        label: '',
        code: ''
      },
      buildings: [],
      buildingDisabled: true
    }
  },
  methods: {
    ...mapActions({
      getStreets: 'address/GET_STREETS',
      saveHouse: 'house/SAVE_HOUSE',
      getStreetBuildings: 'address/GET_STREET_BUILDINGS'
    }),
    loadStreets() {
      this.getStreets()
        .then(resp => {
          let tmp = resp.map(it => {
            return {
              label: it.type + ' ' + it.name,
              code: it.id
            }
          })
          this.options = tmp
        })
        .catch(() => (this.address = this.addressId))
    },
    Save() {
      this.$v.$touch()
      if (!this.$v.$error) {
        let house = {
          description: `Дом ${this.building.code}`,
          streetId: this.street.code,
          building: this.building.code,
          communityId: this.id
        }
        this.saveHouse(house)
          .then(() => {
            this.$emit('save')
            this.$modal.hide('new-house-form')
          })
          .catch(err => {
            this.errorMessage = {err}.err.response.data
          })
      } else {
        this.errorMessage = 'Правильно заполните поля!'
      }
    },
    clearHouse() {
      this.building = {
        label: '',
        code: ''
      }
    },
    updateHouses(val) {
      if (val) {
        this.getStreetBuildings(this.street.code)
          .then(resp => {
            let tmp = resp.map(it => {
              return {
                label: it,
                code: it
              }
            })
            this.buildings = tmp
          })
          .catch(() => (this.address = this.addressId))
        this.buildingDisabled = false
      } else {
        this.building = ''
        this.buildings = []
        this.buildingDisabled = true
        this.apartment = ''
        this.apartments = []
        this.apartmentDisabled = true
      }
    },
    clearData() {
      this.errorMessage = ''
      this.street = {
        label: ''
      }
      this.building = {
        label: ''
      }
      this.$v.$reset()
    }
  },
  validations: {
    street: {
      label: {
        required
      }
    },
    building: {
      label: {
        required
      }
    }
  },
  mounted() {
    this.loadStreets()
  }
}
</script>
